import User from "./controllers/User";
import ListingDetail from "./controllers/ListingDetail";
import AddListing from "./controllers/AddListing";
import Payment from "./controllers/Payment";
import Package from "./controllers/Package";
import Seller from "./controllers/Seller";
import Home from "./controllers/HomeController";
import Category from "./controllers/Category";
import Favourite from "./controllers/Favourite";
import ListingAdmin from "./controllers/ListingAdmin";
import UserListing from "./controllers/UserListing";
import UserMessage from "./controllers/UserMessage";
import UserDashboard from "./controllers/UserDashboard"
import AdminMessage from "./controllers/AdminMessage"
import UserContact from "./controllers/UserContact"
import EmailTemplate from "./controllers/EmailTemplate"
import AdminManager from "./controllers/AdminManager"
import UserManager from "./controllers/UserManager"
import AdminDashBoard from "./controllers/AdminDashboard"
import AdminAnalytics from "./controllers/AdminAnalytics"
import SiteConfig from "./controllers/SiteConfig"
import UserAnalytics from "./controllers/UserAnalytics"
import Faq from "./controllers/Faq"
import AdsController from "./controllers/AdsController"
import ChatController from "./controllers/ChatMessages"
import AdminAgencyController from "./controllers/AdminAgency"
import AdminMediaController from "./controllers/AdminMedia"
import AdminHotdealsController from "./controllers/AdminHotdeals"
import AdminDiscountCode from "./controllers/AdminDiscountCode"

export default {
    modules: {
        UserController: User,
        ListingDetailController: ListingDetail,
        AddListingController: AddListing,
        PaymentController: Payment,
        PackageController: Package,
        SellerController: Seller,
        HomeController: Home,
        CategoryController: Category,
        FavouriteController: Favourite,
        ListingAdminController: ListingAdmin,
        UserListingController: UserListing,
        UserMessageController: UserMessage,
        UserDashboardController: UserDashboard,
        AdminMessageController: AdminMessage,
        UserContactController: UserContact,
        EmailTemplateController: EmailTemplate,
        AdminManagerController: AdminManager,
        UserManagerController: UserManager,
        AdminDashBoardController:AdminDashBoard,
        AdminAnalyticsController:AdminAnalytics,
        SiteConfigController:SiteConfig,
        UserAnalyticsController:UserAnalytics,
        FaqController:Faq,
        AdsController: AdsController,
        ChatController: ChatController,
        AdminAgencyController: AdminAgencyController,
        AdminMediaController: AdminMediaController,
        AdminHotdealsController: AdminHotdealsController,
        AdminDiscountCode: AdminDiscountCode,
    }
};